import ErrorStackParser from 'error-stack-parser';
import StackTraceGPS from 'stacktrace-gps';
import { isMobile } from 'react-device-detect';

import { sendErrorMail } from '../error-tracking/index';

const errorHandler = (error) => {

    const successCallback = (errorData) => {

        const newErrorData = {
            ...errorData,
            isMobile,
            errorMessage: error.message
        }
        
        const postData = {
            "errors"     : JSON.stringify(newErrorData),
        }
        
        sendErrorMail(postData)
        .then((
            // res
            )=> {
            console.log("Error Has Been Logged.");
        })
        .catch((error2)=>{
            console.log("Error while logging!",error2);
        })
    }

    const errorCallback = (error3) => {
        console.log("Failed to log error!",error3);
    }

    const stackframe = ErrorStackParser.parse(error);
    let gps = new StackTraceGPS();
    gps.pinpoint(stackframe[0]).then(successCallback, errorCallback);
    
}
 
export default errorHandler;